import { FC } from 'react';
import { DashboardLayout } from '@components/layout/DashboardLayout';
import { MarketStatsWidget } from '@components/market/MarketStatsWidget';

export const Dashboard: FC = () => {
  return (
    <DashboardLayout title="Tableau de bord">
      <div className="max-w-7xl mx-auto p-6 space-y-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
          Tableau de bord
        </h1>

        <section>
          <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-4">
            Suivi du marché
          </h2>
          <MarketStatsWidget />
        </section>
      </div>
    </DashboardLayout>
  );
};
